import { Controller } from "@hotwired/stimulus";
import { visit } from "@hotwired/turbo";

export default class extends Controller {
  static values = { current: String };
  static targets = ["tab"];

  connect() {
    // A ?view= in the URL is always deliberate -- a bookmark, a shared link, or
    // one of the prev/next-week links the app builds itself -- so it wins, and
    // becomes the stored preference. The stored value used to win instead,
    // which silently rewrote every deep link back to itself (StreamCommand-6zg6).
    if (new URLSearchParams(window.location.search).has("view")) {
      localStorage.setItem("schedule-view", this.currentValue || "agenda");
      return;
    }

    const saved = localStorage.getItem("schedule-view");
    if (!saved) {
      localStorage.setItem("schedule-view", this.currentValue || "agenda");
    } else if (saved !== this.currentValue) {
      // The URL carries no view at all here, so there is nothing to preserve.
      const url = new URL(window.location.href);
      url.searchParams.set("view", saved);
      visit(url.toString(), { action: "replace" });
    }
  }

  switchView(e) {
    const view = e.params.view;
    localStorage.setItem("schedule-view", view);
    this.tabTargets.forEach((t) => {
      t.classList.toggle("tab-active", t.dataset.scheduleViewViewParam === view);
    });
  }
}
